function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Ebene_1"
}, /*#__PURE__*/React.createElement("title", null, "VF_"), /*#__PURE__*/React.createElement("g", {
  id: "Layer_1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M189.9 66.9l39.5 39.6-172.4-.1v28.2l172.3.1-39.4 39.5 19.9 20.1 73.6-73.8-73.5-73.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.3 255.1V0H0v283.5h283.5v-28.4z"
})))));